import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';

import { UserSettingsWrapper } from 'libs/rendering/components/header/collaboratorsSettings.styled';
import { SectionTitle } from 'apps/group/styles';

import { Spinner } from 'components';

import { CollaboratorsOverview } from '../views/collaboratorsOverview';

type CollaboratorsProps = {
  loading: boolean;
  collaborators: {
    username?: string;
    avatarUrl?: string;
    participantDisplayName?: string;
    imageFallbackChar: string;
    fullName: string;
  }[];
  onRequeryCollaborators: (slug: string) => void;
  onRemoveCollaborators: (
    payload: {
      spaceId: string;
      userName: string;
    },
    callbacks: {
      onSuccess: () => void;
      onUserErr: (error: any) => void;
      onSysErr: (error: any) => void;
    },
  ) => void;
};

export const Collaborators = observer((props: CollaboratorsProps) => {
  const {
    collaborators,
    loading,
    onRemoveCollaborators,
    onRequeryCollaborators,
  } = props;

  return (
    <>
      <UserSettingsWrapper
        data-testid='team-members-collaborators'
        borderless={true}
        style={{ maxWidth: '70%', padding: '1rem' }}
      >
        <SectionTitle
          level={2}
          size='medium'
          border
          style={{
            marginLeft: 16,
          }}
        >
          <Trans>Outside Collaborators</Trans>
        </SectionTitle>
        <div className='ml-4'>
          {loading !== false ? (
            <Spinner margin='20px auto' />
          ) : (
            <>
              <div className='md:flex md:justify-between mt-2'>
                {collaborators?.length ? (
                  <CollaboratorsOverview
                    className='max-h-64 w-2/3'
                    collaborators={collaborators}
                    onRequeryCollaborators={onRequeryCollaborators}
                    onRemoveCollaborators={onRemoveCollaborators}
                  />
                ) : (
                  <span className='text-black'>
                    You have no collaborators yet.
                  </span>
                )}
              </div>
            </>
          )}
        </div>
      </UserSettingsWrapper>
    </>
  );
});
